









import Vue from 'vue'
import Component from 'vue-class-component'
import LoadingBar from '@/components/LoadingBar.vue'

@Component({
  components: {
    LoadingBar
  }
})
export default class App extends Vue {

}
